export const CompanySiteDetails = {
    GET_COMPANYWITHSITES: "GET_COMPANYSWITHSITES",
    POST_COMPANYWITHSITES: "POST_COMPANYSWITHSITES",
    UPDATE_SITESANDCOMPANIES: "UPDATE_SITESANDCOMPANIES",
    DELETE_COMPANYWITHSITES: "DELETE_COMPANYWITHSITES",
}
